import { Button } from "../../../components/ui/button";
import { Card } from "../../../components/ui/card";

export const AboutSection = () => {
  const numerologyNumbers = [8, 3, 5, 8, 6, 5];

  const handleScrollToPricing = () => {
    const element = document.getElementById("pricing-section");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="bg-gradient-to-b from-cosmic-red/10 to-background-red">
      <div className="container mx-auto px-6">
        {/* Floating Numbers */}
        <div className="flex justify-center mb-16 space-x-2 sm:space-x-4">
          {numerologyNumbers.map((number, index) => (
            <div 
              key={index}
              className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-gradient-to-br from-cosmic-gold to-cosmic-gold-dark flex items-center justify-center text-xl sm:text-2xl font-bold text-primary-foreground shadow-[0_0_20px_hsl(var(--mystic-gold)/0.4)] animate-bounce"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              {number}
            </div>
          ))}
        </div>

        {/* About Numerology */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl uppercase tracking-wider text-cosmic-gold mb-8">Numerology</h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            is an ancient science that tells you how every Number from 1 to 9 influences our personality, decisions, and life path.
            We use time-tested strategies to analyze your date of birth in great detail and give you a comprehensive report. 
            This report will not only help you understand yourself better but also help you make better decisions that 
            impact both your personal and professional life.
          </p>
        </div>

        {/* Social Proof */}
        <Card className="p-8 md:p-12 bg-gradient-to-b from-cosmic-gold/10 to-cosmic-glow/10 border-cosmic-gold/30 backdrop-blur-sm">
          <div className="text-center">
            <div className="text-6xl font-bold text-cosmic-gold mb-4">10L+</div>
            <div className="text-xl text-foreground font-semibold mb-8">REPORTS HAVE BEEN SOLD ALREADY!</div>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button onClick={handleScrollToPricing} variant="cosmic" size="xl">
                GET YOUR REPORT NOW
              </Button>
              <Button onClick={handleScrollToPricing} variant="cosmic-outline" size="xl" className="hidden md:block">
                GET YOUR REPORT NOW
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </section>
  );
};